import { render, staticRenderFns } from "./color-swatch.vue?vue&type=template&id=dd32b744&scoped=true&"
import script from "./color-swatch.vue?vue&type=script&lang=js&"
export * from "./color-swatch.vue?vue&type=script&lang=js&"
import style0 from "./color-swatch.vue?vue&type=style&index=0&id=dd32b744&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd32b744",
  null
  
)

export default component.exports